import * as FormsApiService from '../Common/Services/FormsApiService';
import actionTypes from './formTemplates.actionTypes';
import { addErrorMessage } from '../Common/Components/flashMessage/flashMessage.actions';


export const loadFormTemplates = (companyId, employeeId, formTypeId, moduleId = null) => {
  return async dispatch => {
    dispatch({ type: actionTypes.FETCH_FORM_TEMPLATES_BEGIN, payload: { companyId, employeeId } });

    const response = moduleId ? await FormsApiService.getModuleFormTemplates(moduleId, formTypeId)
    : await FormsApiService.getFormTemplates(companyId, employeeId, formTypeId);

    if (response) {
      dispatch({ type: actionTypes.FETCH_FORM_TEMPLATES_SUCCESS, data: response.data });
    }
    else {
      dispatch({ type: actionTypes.FETCH_FORM_TEMPLATES_FAILURE });
      dispatch(addErrorMessage('Error retrieving form templates.', 'Error'));
    }
  };
};


export const loadDefaultFormTemplates = (companyId, employeeId, formTypeId, moduleId = null) => {
  return async dispatch => {
    dispatch({ type: actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_BEGIN, payload: { companyId, employeeId } });

    const response = moduleId ? await FormsApiService.getModuleFormTemplates(moduleId, formTypeId, true)
    : await FormsApiService.getFormTemplates(companyId, employeeId, formTypeId, true);

    if (response) {
      dispatch({ type: actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_SUCCESS, data: response.data });
    }
    else {
      dispatch({ type: actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_FAILURE });
      dispatch(addErrorMessage('Error retrieving default form templates.', 'Error'));
    }
  };
};

